import { render } from "./companyAuthed.vue?vue&type=template&id=37180415&scoped=true"
import script from "./companyAuthed.vue?vue&type=script&lang=js"
export * from "./companyAuthed.vue?vue&type=script&lang=js"

import "./companyAuthed.vue?vue&type=style&index=0&id=37180415&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-37180415"

export default script